import React, { useCallback, useEffect, useState, useMemo, useRef } from 'react';
import { Link, Redirect } from 'react-router-dom';
import m1i from '../resources/images/m1i.png'
import m2i from '../resources/images/m2i.png'
import m3i from '../resources/images/m3i.png'
import '../css/Admin_css/admin-customize.css';
import MyLoader from '../Spinner/MyLoader';
import SessionManager from '../Utils/SessionManager';
import axios from 'axios';
import CurrentDue from '../cms/CurrentDue';
import FeeCollection from '../cms/FeeCollection';
import TotalRecieved from '../cms/TotalRecieved';
import TotalDue from '../cms/TotalDue';
import TotalFee from '../cms/TotalFee';
import OldDueList from '../Admin/OldDueList';
import FeeStructureManager from '../cms/FeeStructureManager';
import myToast from '../Utils/MyToast';
import COLORS from '../resources/colors/COLORS';
import uploadIcon from '../resources/images/upload-icon.png'
import MdlSelectSession from '../dialog/MdlSelectSession';

const RevenueManagement = () => {
  const [loggedIn] = useState(!!localStorage.getItem('token'));
  const [isOpenSessionDialog, setIsOpenSessionDialog] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const [sessionName, setSessionName] = useState('');
  const [sessionStatus, setSessionStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [feeDashData, setFeeDashData] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dateRangePreset, setDateRangePreset] = useState('today');
  const [showCalendar, setShowCalendar] = useState(true);
  const [calendarMonth, setCalendarMonth] = useState(new Date());
  const [selectingStartDate, setSelectingStartDate] = useState(true);

  const feeBreakdownData = useMemo(() => {
    const fees = feeDashData[0]?.collection_by_fee || [];
    return [...fees].sort(
      (a, b) => Number(b.collection || 0) - Number(a.collection || 0)
    );
  }, [feeDashData]);

  const collectorData = useMemo(
    () => feeDashData[0]?.collection_by_collector || [],
    [feeDashData]
  );

  const collectionAmount = useMemo(
    () => feeBreakdownData.reduce((sum, fee) => sum + Number(fee.collection || 0), 0),
    [feeBreakdownData]
  );

  const expensesAmount = useMemo(
    () => collectorData.reduce((sum, collector) => sum + Number(collector.expense || 0), 0),
    [collectorData]
  );

  const prevSessionIdRef = useRef('');

  // Helper function to format date as YYYY-MM-DD using local time
  const formatDateLocal = useCallback((date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }, []);

  const getFeeDashBoard = useCallback((options = {}) => {
    const { showLoader = true, start_date, end_date } = options;
    const rangeStart = start_date ?? startDate;
    const rangeEnd = end_date ?? endDate;

    if (!sessionId || !rangeStart || !rangeEnd) {
      return;
    }

    if (showLoader) {
      setLoading(true);
    }

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = 'getFeeDashboard.php';
    const URL =
      process.env.REACT_APP_SERVER_NAME +
      process.env.REACT_APP_TARGET_DIR +
      FUNCTION_NAME;
    console.log('URL>>>>>', URL);
    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          session_id: sessionId,
          start_date: rangeStart,
          end_date: rangeEnd,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoading(false);
        console.log('Response2>>>>>', response);
        const api_status = response.api_status;
        if (api_status === 'OK') {
          setFeeDashData(response.data || []);
        } else {
          const api_remark = response.api_remark;
          myToast.notify_warning(api_remark);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.log('error>>>>>', error);
      });
  }, [sessionId, startDate, endDate]);

  useEffect(() => {
    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession.length > 0) {
      setSessionId(mSession[0].session_id);
      setSessionName(mSession[0].session_name);
      setSessionStatus(mSession[0].status || '');
    }

    const today = new Date();
    const dateStr = formatDateLocal(today);
    setStartDate(dateStr);
    setEndDate(dateStr);
  }, [formatDateLocal]);

  useEffect(() => {
    if (!sessionId || !startDate || !endDate) {
      return;
    }
    const showLoader = prevSessionIdRef.current !== sessionId;
    prevSessionIdRef.current = sessionId;
    getFeeDashBoard({ showLoader });
  }, [sessionId, startDate, endDate, getFeeDashBoard]);

  const handleShowSessionDialog = () => {
    setIsOpenSessionDialog((prev) => !prev);
  };

  const handleCloseSessionDialog = () => {
    setIsOpenSessionDialog(false);
  };

  const handleSelectedSession = (session_id, session_name, session_status, start_date, end_date) => {
    setSessionId(session_id);
    setSessionName(session_name);
    setSessionStatus(session_status || '');
    setIsOpenSessionDialog(false);
  };

  const changeSession = () => {
    handleShowSessionDialog();
  };

  const handleDateRangePreset = (preset) => {
    const today = new Date();
    let newStartDate = '';
    let newEndDate = '';

    switch (preset) {
      case 'today':
        newStartDate = newEndDate = formatDateLocal(today);
        break;
      case 'yesterday': {
        const yesterday = new Date(today);
        yesterday.setDate(today.getDate() - 1);
        newStartDate = newEndDate = formatDateLocal(yesterday);
        break;
      }
      case 'thisWeek': {
        const startOfWeek = new Date(today);
        startOfWeek.setDate(today.getDate() - today.getDay());
        newStartDate = formatDateLocal(startOfWeek);
        newEndDate = formatDateLocal(today);
        break;
      }
      case 'lastWeek': {
        const lastWeekEnd = new Date(today);
        lastWeekEnd.setDate(today.getDate() - today.getDay() - 1);
        const lastWeekStart = new Date(lastWeekEnd);
        lastWeekStart.setDate(lastWeekEnd.getDate() - 6);
        newStartDate = formatDateLocal(lastWeekStart);
        newEndDate = formatDateLocal(lastWeekEnd);
        break;
      }
      case 'last7Days': {
        const last7Days = new Date(today);
        last7Days.setDate(today.getDate() - 7);
        newStartDate = formatDateLocal(last7Days);
        newEndDate = formatDateLocal(today);
        break;
      }
      case 'thisMonth': {
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        newStartDate = formatDateLocal(startOfMonth);
        newEndDate = formatDateLocal(today);
        break;
      }
      case 'lastMonth': {
        const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
        newStartDate = formatDateLocal(firstDayLastMonth);
        newEndDate = formatDateLocal(lastDayLastMonth);
        break;
      }
      case 'last30Days': {
        const last30Days = new Date(today);
        last30Days.setDate(today.getDate() - 30);
        newStartDate = formatDateLocal(last30Days);
        newEndDate = formatDateLocal(today);
        break;
      }
      case 'custom':
        break;
      default:
        return;
    }

    setDateRangePreset(preset);
    setStartDate(newStartDate || startDate);
    setEndDate(newEndDate || endDate);
  };

  const handleCalendarDateClick = (date) => {
    const dateStr = formatDateLocal(date);
    
    if (selectingStartDate || !startDate || dateStr < startDate) {
      setStartDate(dateStr);
      setEndDate('');
      setSelectingStartDate(false);
      setDateRangePreset('custom');
    } else {
      setEndDate(dateStr);
      setSelectingStartDate(true);
      setDateRangePreset('custom');
    }
  };

  const navigateCalendarMonth = (direction) => {
    const newMonth = new Date(calendarMonth);
    newMonth.setMonth(newMonth.getMonth() + direction);
    setCalendarMonth(newMonth);
  };

  const generateCalendarDays = useMemo(() => {
    const year = calendarMonth.getFullYear();
    const month = calendarMonth.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    
    const days = [];
    for (let day = 1; day <= daysInMonth; day++) {
      days.push(new Date(year, month, day));
    }
    
    return days;
  }, [calendarMonth]);

  const isDateInRange = (date) => {
    if (!startDate || !endDate) return false;
    const dateStr = formatDateLocal(date);
    return dateStr >= startDate && dateStr <= endDate;
  };

  const isDateSelected = (date) => {
    const dateStr = formatDateLocal(date);
    return dateStr === startDate || dateStr === endDate;
  };

  const isToday = (date) => {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (loading) {
    return <MyLoader />;
  }

    return (
    <div className="content" style={{ background: COLORS.white }}>
          <div className="content-header">
            <div className="leftside-content-header">
              <ul className="breadcrumbs">
                <li>
                  <i className="fa fa-home" aria-hidden="true" />
                  <a href="#">Revenue Management</a>
                </li>
              </ul>
            </div> 
          </div>

          {/* Main Revenue Card */}
          <div
            className="bg_page_white_rounded box_shadow animated fadeInUp"
            style={{
              '--mMargin': '30px',
              padding: 0,
              overflow: 'hidden',
              borderRadius: '14px',
            }}
          >
            {/* Session Selection */}
            <div
              style={{
                background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                borderRadius: "16px 16px 0 0",
                padding: "0",
                marginBottom: "0",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08), 0 2px 4px rgba(0, 0, 0, 0.04)",
                border: "2px solid #e5e7eb",
                borderBottom: "none",
                overflow: "hidden",
              }}
            >
              <Link
                to="#"
                onClick={(e) => {
                  e.preventDefault();
                  setIsOpenSessionDialog(true);
                }}
                style={{ textDecoration: "none" }}
              >
                <div
                  style={{
                    background: `linear-gradient(135deg, ${COLORS.primary_color_shade5 || "#3b82f6"} 0%, ${COLORS.primary_color_shade4 || "#2563eb"} 100%)`,
                    borderRadius: "14px 14px 0 0",
                    padding: "12px 20px",
                    marginBottom: "0",
                    boxShadow: "none",
                    border: "none",
                    cursor: "pointer",
                    transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                    borderBottom: "2px solid rgba(255, 255, 255, 0.1)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-1px) scale(1.005)";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.18), 0 2px 6px rgba(0, 0, 0, 0.12)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0) scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <i
                        className="fa fa-calendar"
                        style={{
                          fontSize: "20px",
                          color: "#ffffff",
                          opacity: 0.9,
                        }}
                      ></i>
                      <div>
                        <p
                          style={{
                            margin: 0,
                            fontSize: "16px",
                            fontWeight: "700",
                            color: "#ffffff",
                            lineHeight: "1.4",
                          }}
                        >
                          {sessionName || "Select Session"}
                        </p>
                        {sessionStatus && (
                          <p
                            style={{
                              margin: "2px 0 0 0",
                              fontSize: "12px",
                              color: "rgba(255, 255, 255, 0.85)",
                              fontWeight: "500",
                            }}
                          >
                            Status: {sessionStatus}
                          </p>
                        )}
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "40px",
                        height: "40px",
                        borderRadius: "10px",
                        background: "rgba(255, 255, 255, 0.2)",
                        transition: "all 0.3s ease",
                      }}
                    >
                      <i
                        className="fa fa-chevron-right"
                        style={{
                          fontSize: "16px",
                          color: "#ffffff",
                          opacity: 0.9,
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            {/* Card body */}
            <div style={{ padding: '20px 24px 24px 24px' }}>
              {/* Date Range Section */}
              <div
                style={{
                  background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                  borderRadius: "12px",
                  border: "2px solid #e5e7eb",
                  padding: "12px 16px",
                  marginBottom: "20px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                }}
              >
                <h5 style={{ margin: 0, marginBottom: "12px", fontSize: "16px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                  <i className="fa fa-calendar-alt" style={{ color: "#3b82f6", fontSize: "16px" }}></i>
                  Revenue Overview
                </h5>
                
                {/* Quick Date Range Buttons - Modern */}
                <div style={{ marginBottom: "12px" }}>
                  <div style={{ 
                    display: "grid", 
                    gridTemplateColumns: "repeat(auto-fit, minmax(110px, 1fr))", 
                    gap: "8px" 
                  }}>
                    {[
                      { value: "today", label: "Today", icon: "fa-calendar-day", color: "#10b981" },
                      { value: "yesterday", label: "Yesterday", icon: "fa-calendar-minus", color: "#6366f1" },
                      { value: "thisWeek", label: "This Week", icon: "fa-calendar-week", color: "#3b82f6" },
                      { value: "lastWeek", label: "Last Week", icon: "fa-calendar-week", color: "#a855f7" },
                      { value: "last7Days", label: "Last 7 Days", icon: "fa-calendar", color: "#8b5cf6" },
                      { value: "thisMonth", label: "This Month", icon: "fa-calendar-alt", color: "#f59e0b" },
                      { value: "lastMonth", label: "Last Month", icon: "fa-calendar-check", color: "#ef4444" },
                      { value: "last30Days", label: "Last 30 Days", icon: "fa-calendar", color: "#06b6d4" },
                    ].map((preset) => {
                      const isSelected = dateRangePreset === preset.value;
                      return (
                        <button
                          key={preset.value}
                          type="button"
                          onClick={() => handleDateRangePreset(preset.value)}
                          style={{
                            padding: "10px 12px",
                            fontSize: "12px",
                            fontWeight: isSelected ? "700" : "600",
                            borderRadius: "10px",
                            border: isSelected
                              ? `2px solid ${preset.color}`
                              : "2px solid #e5e7eb",
                            background: isSelected
                              ? `linear-gradient(135deg, ${preset.color} 0%, ${preset.color}dd 100%)`
                              : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                            color: isSelected ? "#ffffff" : "#374151",
                            cursor: "pointer",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "4px",
                            boxShadow: isSelected
                              ? `0 4px 12px ${preset.color}40, 0 2px 4px rgba(0, 0, 0, 0.1)`
                              : "0 2px 4px rgba(0, 0, 0, 0.05)",
                            transform: isSelected ? "translateY(-2px)" : "translateY(0)",
                            whiteSpace: "nowrap",
                          }}
                          onMouseEnter={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.background = `linear-gradient(135deg, ${preset.color}15 0%, ${preset.color}08 100%)`;
                              e.currentTarget.style.borderColor = preset.color;
                              e.currentTarget.style.transform = "translateY(-2px)";
                              e.currentTarget.style.boxShadow = `0 4px 12px ${preset.color}30, 0 2px 4px rgba(0, 0, 0, 0.1)`;
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.background = "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)";
                              e.currentTarget.style.borderColor = "#e5e7eb";
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                            }
                          }}
                        >
                          <div style={{
                            width: "24px",
                            height: "24px",
                            borderRadius: "6px",
                            background: isSelected
                              ? "rgba(255, 255, 255, 0.2)"
                              : `${preset.color}15`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            transition: "all 0.3s ease",
                            flexShrink: 0,
                          }}>
                            <i 
                              className={`fa ${preset.icon}`} 
                              style={{ 
                                fontSize: "12px",
                                color: isSelected ? "#ffffff" : preset.color
                              }}
                            ></i>
                          </div>
                          <span style={{ flex: 1, textAlign: "left", whiteSpace: "nowrap" }}>{preset.label}</span>
                          {isSelected && (
                            <i 
                              className="fa fa-check-circle" 
                              style={{ 
                                fontSize: "12px",
                                color: "#ffffff",
                                flexShrink: 0,
                              }}
                            ></i>
                          )}
                        </button>
                      );
                    })}
                  </div>
                  </div>
                 
                {/* Calendar View */}
                <div>
                  {showCalendar && (
                    <div
                      style={{
                        background: "#ffffff",
                        borderRadius: "12px",
                        border: "2px solid #e5e7eb",
                        padding: "8px 10px",
                        marginBottom: "20px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                      }}
                    >
                      {/* Calendar Header - Compact */}
                      <div style={{ 
                        display: "flex", 
                        justifyContent: "space-between", 
                        alignItems: "center", 
                        marginBottom: "8px",
                        background: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
                        padding: "8px 12px",
                        borderRadius: "10px",
                        border: "1px solid #bfdbfe"
                      }}>
                        <button
                          type="button"
                          onClick={() => navigateCalendarMonth(-1)}
                          style={{
                            padding: "4px 8px",
                            borderRadius: "6px",
                            border: "1px solid #93c5fd",
                            background: "#ffffff",
                            cursor: "pointer",
                            fontSize: "12px",
                            color: "#374151",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f3f4f6";
                            e.currentTarget.style.borderColor = "#60a5fa";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#ffffff";
                            e.currentTarget.style.borderColor = "#93c5fd";
                          }}
                        >
                          <i className="fa fa-chevron-left"></i>
                        </button>
                        <h6 style={{ 
                          margin: 0, 
                          fontSize: "14px", 
                          fontWeight: "700", 
                          color: "#1e40af"
                        }}>
                          {calendarMonth.toLocaleString("default", { month: "short", year: "numeric" })}
                        </h6>
                        <button
                          type="button"
                          onClick={() => navigateCalendarMonth(1)}
                          style={{
                            padding: "4px 8px",
                            borderRadius: "6px",
                            border: "1px solid #93c5fd",
                            background: "#ffffff",
                            cursor: "pointer",
                            fontSize: "12px",
                            color: "#374151",
                            transition: "all 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f3f4f6";
                            e.currentTarget.style.borderColor = "#60a5fa";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "#ffffff";
                            e.currentTarget.style.borderColor = "#93c5fd";
                          }}
                        >
                          <i className="fa fa-chevron-right"></i>
                        </button>
                      </div>

                      {/* Calendar - Single Row with 100% Width */}
                      <div style={{ width: "100%", overflowX: "hidden" }}>
                        <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                          {/* Weekday Headers - Single Row */}
                          <div style={{ 
                            display: "flex", 
                            gap: "1px", 
                            marginBottom: "3px", 
                            width: "100%"
                          }}>
                            {generateCalendarDays.map((date, index) => {
                              const dayIndex = date.getDay();
                              const dayNames = ["S", "M", "T", "W", "T", "F", "S"];
                              return (
                                <div
                                  key={`header-${index}`}
                                  style={{
                                    textAlign: "center",
                                    fontSize: "12px",
                                    fontWeight: "600",
                                    color: "#475569",
                                    padding: "4px 1px",
                                    flex: "1",
                                    minWidth: 0,
                                    height: "24px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {dayNames[dayIndex]}
                                </div>
                              );
                            })}
                  </div>

                          {/* Calendar Days - Single Row */}
                          <div style={{ display: "flex", gap: "1px", width: "100%" }}>
                            {generateCalendarDays.map((date, index) => {
                              const dateStr = formatDateLocal(date);
                              const isInRange = isDateInRange(date);
                              const isSelected = isDateSelected(date);
                              const isTodayDate = isToday(date);
                              const isStartDate = dateStr === startDate;
                              const isEndDate = dateStr === endDate;
                              const isCurrentMonth = date.getMonth() === calendarMonth.getMonth();

                              return (
                                <button
                                  key={dateStr}
                                  type="button"
                                  onClick={() => handleCalendarDateClick(date)}
                                  style={{
                                    padding: "4px 1px",
                                    fontSize: "12px",
                                    fontWeight: isSelected ? "700" : "500",
                                    borderRadius: "50%",
                                    border: isSelected
                                      ? "2px solid #3b82f6"
                                      : isInRange
                                      ? "1px solid #bfdbfe"
                                      : "1px solid transparent",
                                    background: isStartDate || isEndDate
                                      ? "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)"
                                      : isInRange
                                      ? "#eff6ff"
                                      : isTodayDate
                                      ? "#fef3c7"
                                      : !isCurrentMonth
                                      ? "#e5e7eb"
                                      : "#e2e8f0",
                                    color: isStartDate || isEndDate
                                      ? "#ffffff"
                                      : isTodayDate && !isInRange
                                      ? "#92400e"
                                      : !isCurrentMonth
                                      ? "#9ca3af"
                                      : "#374151",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    position: "relative",
                                    minHeight: "32px",
                                    flex: "1",
                                    minWidth: 0,
                                    aspectRatio: "1",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                  onMouseEnter={(e) => {
                                    if (!isSelected && !isInRange && !isTodayDate) {
                                      e.currentTarget.style.background = "#f1f5f9";
                                      e.currentTarget.style.borderColor = "#cbd5e1";
                                    }
                                  }}
                                  onMouseLeave={(e) => {
                                    if (!isSelected && !isInRange && !isTodayDate) {
                                      e.currentTarget.style.background = !isCurrentMonth 
                                        ? "#e5e7eb" 
                                        : "#e2e8f0";
                                      e.currentTarget.style.borderColor = "transparent";
                                    }
                                  }}
                                  title={`${date.toLocaleDateString()}`}
                                >
                                  <div style={{ fontSize: "13px", lineHeight: "1.3", fontWeight: "600" }}>{date.getDate()}</div>
                                  {date.getDate() === 1 && (
                                    <div style={{ fontSize: "9px", color: "#9ca3af", marginTop: "2px", fontWeight: "500" }}>
                                      {date.toLocaleString("default", { month: "short" }).substring(0, 3)}
                      </div>
                                  )}
                                </button>
                              );
                            })}
                  </div>
                </div>
                </div>              
              </div>
                  )}

                  {/* Custom Date Range Inputs */}
                  <div style={{ marginTop: "20px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "16px", flexWrap: "wrap" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: "1", minWidth: "200px" }}>
                        <label style={{ fontWeight: "600", fontSize: "14px", color: "#374151", margin: 0, whiteSpace: "nowrap" }}>
                          Start Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => {
                            setStartDate(e.target.value);
                            setDateRangePreset("custom");
                          }}
                          style={{
                            padding: "10px 14px",
                            fontSize: "14px",
                            fontWeight: "600",
                            borderRadius: "10px",
                            border: "2px solid #e5e7eb",
                            cursor: "pointer",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                            color: "#374151",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                            flex: 1,
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#3b82f6";
                            e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(59, 130, 246, 0.15)";
                            e.target.style.transform = "translateY(-2px)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#e5e7eb";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                            e.target.style.transform = "translateY(0)";
                          }}
                          onMouseEnter={(e) => {
                            if (document.activeElement !== e.target) {
                              e.target.style.borderColor = "#93c5fd";
                              e.target.style.boxShadow = "0 4px 8px rgba(59, 130, 246, 0.1)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (document.activeElement !== e.target) {
                              e.target.style.borderColor = "#e5e7eb";
                              e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                            }
                          }}
                        />
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px", flex: "1", minWidth: "200px" }}>
                        <label style={{ fontWeight: "600", fontSize: "14px", color: "#374151", margin: 0, whiteSpace: "nowrap" }}>
                          End Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={endDate}
                          onChange={(e) => {
                            setEndDate(e.target.value);
                            setDateRangePreset("custom");
                          }}
                          min={startDate}
                          style={{
                            padding: "10px 14px",
                            fontSize: "14px",
                            fontWeight: "600",
                            borderRadius: "10px",
                            border: "2px solid #e5e7eb",
                            cursor: "pointer",
                            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                            color: "#374151",
                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
                            flex: 1,
                          }}
                          onFocus={(e) => {
                            e.target.style.borderColor = "#3b82f6";
                            e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.1), 0 4px 12px rgba(59, 130, 246, 0.15)";
                            e.target.style.transform = "translateY(-2px)";
                          }}
                          onBlur={(e) => {
                            e.target.style.borderColor = "#e5e7eb";
                            e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                            e.target.style.transform = "translateY(0)";
                          }}
                          onMouseEnter={(e) => {
                            if (document.activeElement !== e.target) {
                              e.target.style.borderColor = "#93c5fd";
                              e.target.style.boxShadow = "0 4px 8px rgba(59, 130, 246, 0.1)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (document.activeElement !== e.target) {
                              e.target.style.borderColor = "#e5e7eb";
                              e.target.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                            }
                          }}
                        />
                      </div>
                    </div>
                    {startDate && endDate && (
                      <div style={{ marginTop: "12px", padding: "10px", background: "#eff6ff", borderRadius: "8px", border: "1px solid #bfdbfe" }}>
                        <i className="fa fa-info-circle me-2" style={{ color: "#3b82f6" }}></i>
                        <span style={{ color: "#1e40af", fontWeight: "500", fontSize: "13px" }}>
                          Selected: {new Date(startDate).toLocaleDateString()} - {new Date(endDate).toLocaleDateString()}
                        </span>
                      </div>
                    )}
                  </div>  

                  {/* Collection and Expenses Cards */}
                  {startDate && endDate && (
                    <div style={{ marginTop: "16px" }}>
                      <div style={{ display: "flex", gap: "12px", flexWrap: "nowrap" }}>
                        {/* Collection Card */}
                        <div style={{ flex: "1", minWidth: 0 }}>
                          <div
                            style={{
                              background: "linear-gradient(135deg, #22c55e 0%, #16a34a 100%)",
                              borderRadius: "12px",
                              padding: "16px 18px",
                              color: "#ffffff",
                              boxShadow: "0 4px 16px rgba(16, 185, 129, 0.25), 0 2px 4px rgba(16, 185, 129, 0.15)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "12px",
                              transition: "all 0.3s ease",
                              border: "1px solid rgba(255, 255, 255, 0.1)",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateY(-2px)";
                              e.currentTarget.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.35), 0 4px 8px rgba(16, 185, 129, 0.2)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "0 4px 16px rgba(16, 185, 129, 0.25), 0 2px 4px rgba(16, 185, 129, 0.15)";
                            }}
                          >
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div
                                style={{
                                  fontSize: "11px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.1em",
                                  opacity: 0.95,
                                  marginBottom: "6px",
                                  fontWeight: 600,
                                }}
                              >
                                Collection
                              </div>
                              <div
                                style={{
                                  fontSize: "26px",
                                  fontWeight: 700,
                                  lineHeight: 1.2,
                                  marginBottom: "2px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                ₹{collectionAmount.toLocaleString('en-IN')}
                              </div>
                              <div
                                style={{
                                  fontSize: "11px",
                                  opacity: 0.85,
                                  fontWeight: 500,
                                  marginBottom: "8px",
                                }}
                              >
                                Selected period
                              </div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
                              <button
                                type="button"
                                onClick={() => {
                                  console.log('View Collection Details:', { startDate, endDate });
                                }}
                                style={{
                                  padding: "6px 12px",
                                  fontSize: "11px",
                                  fontWeight: 600,
                                  borderRadius: "6px",
                                  border: "1px solid rgba(255, 255, 255, 0.3)",
                                  backgroundColor: "rgba(255, 255, 255, 0.15)",
                                  color: "#ffffff",
                                  cursor: "pointer",
                                  transition: "all 0.2s ease",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.05em",
                                  backdropFilter: "blur(10px)",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.25)";
                                  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.4)";
                                  e.currentTarget.style.transform = "translateY(-1px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
                                  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.3)";
                                  e.currentTarget.style.transform = "translateY(0)";
                                }}
                              >
                                Details
                              </button>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "48px",
                                  height: "48px",
                                  borderRadius: "50%",
                                  backgroundColor: "rgba(255,255,255,0.2)",
                                  fontSize: "20px",
                                  backdropFilter: "blur(10px)",
                                  border: "1px solid rgba(255,255,255,0.15)",
                                }}
                              >
                                <i className="fa fa-inr" />
                              </div>
                            </div>
                          </div>
               </div>

                        {/* Expenses Card */}
                        <div style={{ flex: "1", minWidth: 0 }}>
                          <div
                            style={{
                              background: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                              borderRadius: "12px",
                              padding: "16px 18px",
                              color: "#ffffff",
                              boxShadow: "0 4px 16px rgba(239, 68, 68, 0.25), 0 2px 4px rgba(239, 68, 68, 0.15)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "12px",
                              transition: "all 0.3s ease",
                              border: "1px solid rgba(255, 255, 255, 0.1)",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateY(-2px)";
                              e.currentTarget.style.boxShadow = "0 6px 20px rgba(239, 68, 68, 0.35), 0 4px 8px rgba(239, 68, 68, 0.2)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "0 4px 16px rgba(239, 68, 68, 0.25), 0 2px 4px rgba(239, 68, 68, 0.15)";
                            }}
                          >
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div
                                style={{
                                  fontSize: "11px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.1em",
                                  opacity: 0.95,
                                  marginBottom: "6px",
                                  fontWeight: 600,
                                }}
                              >
                                Expenses
                </div>
                              <div
                                style={{
                                  fontSize: "26px",
                                  fontWeight: 700,
                                  lineHeight: 1.2,
                                  marginBottom: "2px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                ₹{expensesAmount.toLocaleString('en-IN')}
                              </div>
                              <div
                                style={{
                                  fontSize: "11px",
                                  opacity: 0.85,
                                  fontWeight: 500,
                                  marginBottom: "8px",
                                }}
                              >
                                Selected period
                              </div>
                            </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
                              <button
                                type="button"
                                onClick={() => {
                                  console.log('View Expenses Details:', { startDate, endDate });
                                }}
                                style={{
                                  padding: "6px 12px",
                                  fontSize: "11px",
                                  fontWeight: 600,
                                  borderRadius: "6px",
                                  border: "1px solid rgba(255, 255, 255, 0.3)",
                                  backgroundColor: "rgba(255, 255, 255, 0.15)",
                                  color: "#ffffff",
                                  cursor: "pointer",
                                  transition: "all 0.2s ease",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.05em",
                                  backdropFilter: "blur(10px)",
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.25)";
                                  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.4)";
                                  e.currentTarget.style.transform = "translateY(-1px)";
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.15)";
                                  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.3)";
                                  e.currentTarget.style.transform = "translateY(0)";
                                }}
                              >
                                Details
                              </button>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "48px",
                                  height: "48px",
                                  borderRadius: "50%",
                                  backgroundColor: "rgba(255,255,255,0.2)",
                                  fontSize: "20px",
                                  backdropFilter: "blur(10px)",
                                  border: "1px solid rgba(255,255,255,0.15)",
                                }}
                              >
                                <i className="fa fa-money-bill-wave" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Fee Breakdown */}
                  {startDate && endDate && (
                    <div style={{ marginTop: "10px" }}>
                      <h6 style={{ 
                        margin: 0, 
                        marginBottom: "6px", 
                        fontSize: "14px", 
                        fontWeight: 700, 
                        color: "#111827",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px"
                      }}>
                        <i className="fa fa-money-bill-wave" style={{ color: "#8b5cf6", fontSize: "13px" }}></i>
                        Collection By Fee
                      </h6>
                      {feeBreakdownData.length > 0 ? (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                        {feeBreakdownData.map((fee, index) => (
                          <div
                            key={index}
                            style={{
                              background: "linear-gradient(135deg, #f0fdf4, #dcfce7)",
                              borderRadius: "7px",
                              padding: "5px",
                              border: "1px solid #86efac",
                              boxShadow: "0 1px 2px rgba(16, 185, 129, 0.1)",
                              transition: "all 0.2s ease",
                              display: "flex",
                              alignItems: "flex-start",
                              gap: "7px",
                              flex: "0 1 auto",
                              minWidth: "145px",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateY(-1px)";
                              e.currentTarget.style.boxShadow = "0 2px 6px rgba(16, 185, 129, 0.15)";
                              e.currentTarget.style.borderColor = "#4ade80";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "0 1px 3px rgba(16, 185, 129, 0.1)";
                              e.currentTarget.style.borderColor = "#86efac";
                            }}
                          >
                            {/* Fee Name + Amount */}
                            <div style={{
                              width: "26px",
                              height: "26px",
                              borderRadius: "5px",
                              background: "linear-gradient(135deg, #16a34a, #15803d)",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "#ffffff",
                              fontSize: "12px",
                              fontWeight: 700,
                              flexShrink: 0,
                              marginTop: "1px",
                            }}>
                              {fee.fee_name ? fee.fee_name.charAt(0).toUpperCase() : 'F'}
                            </div>
                            <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: "2px" }}>
                              <div style={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#111827",
                                lineHeight: 1.25,
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                              }}>
                                {fee.fee_name || 'Unknown Fee'}
                              </div>
                              <div style={{
                                fontSize: "14px",
                                fontWeight: 700,
                                color: "#16a34a",
                                lineHeight: 1.15,
                              }}>
                                ₹{(fee.collection || 0).toLocaleString('en-IN')}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      ) : (
                        <div style={{
                          padding: "16px",
                          borderRadius: "8px",
                          background: "#f9fafb",
                          border: "1px dashed #d1d5db",
                          color: "#6b7280",
                          fontSize: "13px",
                          textAlign: "center",
                        }}>
                          No fee types configured
                        </div>
                      )}
                    </div>
                  )}

                  {/* Collector Breakdown */}
                  {startDate && endDate && (
                    <div style={{ marginTop: "12px" }}>
                      <h6 style={{ 
                        margin: 0, 
                        marginBottom: "8px", 
                        fontSize: "14px", 
                        fontWeight: 700, 
                        color: "#111827",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                      }}>
                        <i className="fa fa-users" style={{ color: "#3b82f6", fontSize: "14px" }}></i>
                        Breakdown by Collector
                      </h6>
                      {collectorData.length > 0 ? (
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "8px" }}>
                        {collectorData.map((collector, index) => (
                          <div
                            key={index}
                            style={{
                              background: "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                              borderRadius: "12px",
                              padding: "12px",
                              border: "1px solid #e5e7eb",
                              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)",
                              transition: "all 0.3s ease",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.transform = "translateY(-2px)";
                              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.1)";
                              e.currentTarget.style.borderColor = "#cbd5e1";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.transform = "translateY(0)";
                              e.currentTarget.style.boxShadow = "0 2px 8px rgba(0, 0, 0, 0.06)";
                              e.currentTarget.style.borderColor = "#e5e7eb";
                            }}
                          >
                            {/* Collector Name */}
                            <div style={{ 
                              display: "flex", 
                              alignItems: "center", 
                              gap: "8px",
                              marginBottom: "8px",
                              paddingBottom: "8px",
                              borderBottom: "1px solid #e5e7eb"
                            }}>
                              <div style={{
                                width: "36px",
                                height: "36px",
                                borderRadius: "50%",
                                background: "linear-gradient(135deg, #3b82f6, #2563eb)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#ffffff",
                                fontSize: "14px",
                                fontWeight: 600,
                                flexShrink: 0,
                              }}>
                                {collector.name ? collector.name.charAt(0).toUpperCase() : 'C'}
                              </div>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <div style={{
                                  fontSize: "13px",
                                  fontWeight: 600,
                                  color: "#111827",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}>
                                  {collector.name || 'Unknown Collector'}
                                </div>
                                <div style={{
                                  fontSize: "11px",
                                  color: "#6b7280",
                                  marginTop: "1px",
                                }}>
                                  Collector
                                </div>
                              </div>
                            </div>

                            {/* Collection and Expense */}
                            <div style={{ display: "flex", gap: "6px" }}>
                              {/* Collection */}
                              <div style={{ 
                                flex: 1,
                                background: "linear-gradient(135deg, #ecfdf5, #d1fae5)",
                                borderRadius: "8px",
                                padding: "8px",
                                border: "1px solid #86efac",
                              }}>
                                <div style={{
                                  fontSize: "10px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.05em",
                                  color: "#047857",
                                  fontWeight: 600,
                                  marginBottom: "2px",
                                }}>
                                  Collection
                                </div>
                                <div style={{
                                  fontSize: "18px",
                                  fontWeight: 700,
                                  color: "#16a34a",
                                  lineHeight: 1.2,
                                }}>
                                  ₹{(collector.collection || 0).toLocaleString('en-IN')}
                                </div>
                              </div>

                              {/* Expense */}
                              <div style={{ 
                                flex: 1,
                                background: "linear-gradient(135deg, #fef2f2, #fee2e2)",
                                borderRadius: "8px",
                                padding: "8px",
                                border: "1px solid #fca5a5",
                              }}>
                                <div style={{
                                  fontSize: "10px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.05em",
                                  color: "#991b1b",
                                  fontWeight: 600,
                                  marginBottom: "2px",
                                }}>
                                  Expense
                                </div>
                                <div style={{
                                  fontSize: "18px",
                                  fontWeight: 700,
                                  color: "#dc2626",
                                  lineHeight: 1.2,
                                }}>
                                  ₹{(collector.expense || 0).toLocaleString('en-IN')}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                      ) : (
                        <div style={{
                          padding: "16px",
                          borderRadius: "8px",
                          background: "#f9fafb",
                          border: "1px dashed #d1d5db",
                          color: "#6b7280",
                          fontSize: "13px",
                          textAlign: "center",
                        }}>
                          No collector activity recorded for this period
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              {/* Revenue Metrics Cards */}
              <div
                style={{
                  background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                  borderRadius: "12px",
                  border: "2px solid #e5e7eb",
                  padding: "12px 16px",
                  marginTop: "20px",
                  marginBottom: "20px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                }}
              >
                <h5 style={{ margin: 0, marginBottom: "12px", fontSize: "16px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                  <i className="fa fa-chart-line" style={{ color: "#3b82f6", fontSize: "16px" }}></i>
                  Overview
                </h5>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "12px" }}>
                  {/* Total Due */}
                        <Link to={{pathname:'/AdminMain/TotalDue'}} style={{textDecoration:'none'}}>
                    <div
                      style={{
                        background: "linear-gradient(135deg, #f59e0b, #d97706)",
                        borderRadius: "12px",
                        padding: "16px 18px",
                        color: "#ffffff",
                        boxShadow: "0 4px 16px rgba(245, 158, 11, 0.25), 0 2px 4px rgba(245, 158, 11, 0.15)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(245, 158, 11, 0.35), 0 4px 8px rgba(245, 158, 11, 0.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 4px 16px rgba(245, 158, 11, 0.25), 0 2px 4px rgba(245, 158, 11, 0.15)";
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                        <div style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.08em", opacity: 0.9, fontWeight: 600 }}>
                          Total Due
                        </div>
                        <div style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "8px",
                          backgroundColor: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "14px",
                        }}>
                          <i className="fa fa-exclamation-circle" />
                    </div> 
                      </div>
                      <div style={{ fontSize: "24px", fontWeight: 700, lineHeight: 1.2 }}>
                        ₹{feeDashData.length===0?'0':Number(feeDashData[0].total_due || 0).toLocaleString('en-IN')}
                      </div>
                        </div>
                     </Link>   

                  {/* Current Due */}
                  <Link to={{pathname:'/AdminMain/CurrentDue'}} style={{textDecoration:'none'}}>
                    <div
                      style={{
                        background: "linear-gradient(135deg, #ef4444, #dc2626)",
                        borderRadius: "12px",
                        padding: "16px 18px",
                        color: "#ffffff",
                        boxShadow: "0 4px 16px rgba(239, 68, 68, 0.25), 0 2px 4px rgba(239, 68, 68, 0.15)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(239, 68, 68, 0.35), 0 4px 8px rgba(239, 68, 68, 0.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 4px 16px rgba(239, 68, 68, 0.25), 0 2px 4px rgba(239, 68, 68, 0.15)";
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                        <div style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.08em", opacity: 0.9, fontWeight: 600 }}>
                          Current Due
                  </div> 
                        <div style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "8px",
                          backgroundColor: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "14px",
                        }}>
                          <i className="fa fa-clock" />
                        </div>
                      </div>
                      <div style={{ fontSize: "24px", fontWeight: 700, lineHeight: 1.2 }}>
                        ₹{feeDashData.length===0?'0':Number(feeDashData[0].current_due || 0).toLocaleString('en-IN')}
                      </div>
                    </div>
                  </Link>

                  {/* Total Fee */}
                     <Link to={{pathname:'/AdminMain/TotalFee'}} style={{textDecoration:'none'}}> 
                    <div
                      style={{
                        background: "linear-gradient(135deg, #f97316, #ea580c)",
                        borderRadius: "12px",
                        padding: "16px 18px",
                        color: "#ffffff",
                        boxShadow: "0 4px 16px rgba(249, 115, 22, 0.25), 0 2px 4px rgba(249, 115, 22, 0.15)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(249, 115, 22, 0.35), 0 4px 8px rgba(249, 115, 22, 0.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 4px 16px rgba(249, 115, 22, 0.25), 0 2px 4px rgba(249, 115, 22, 0.15)";
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                        <div style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.08em", opacity: 0.9, fontWeight: 600 }}>
                          Total Fee
                        </div>
                        <div style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "8px",
                          backgroundColor: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "14px",
                        }}>
                          <i className="fa fa-money-bill-wave" />
                  </div>
                      </div>
                      <div style={{ fontSize: "24px", fontWeight: 700, lineHeight: 1.2 }}>
                        ₹{feeDashData.length===0?'0':Number(feeDashData[0].total_fee || 0).toLocaleString('en-IN')}
                      </div>
                        </div>
                     </Link> 

                  {/* Received */}
                  <Link to={{pathname:'/AdminMain/TotalRecieved'}} style={{textDecoration:'none'}}>
                    <div
                      style={{
                        background: "linear-gradient(135deg, #22c55e, #16a34a)",
                        borderRadius: "12px",
                        padding: "16px 18px",
                        color: "#ffffff",
                        boxShadow: "0 4px 16px rgba(16, 185, 129, 0.25), 0 2px 4px rgba(16, 185, 129, 0.15)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(16, 185, 129, 0.35), 0 4px 8px rgba(16, 185, 129, 0.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 4px 16px rgba(16, 185, 129, 0.25), 0 2px 4px rgba(16, 185, 129, 0.15)";
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                        <div style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.08em", opacity: 0.9, fontWeight: 600 }}>
                          Received
                  </div>
                        <div style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "8px",
                          backgroundColor: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "14px",
                        }}>
                          <i className="fa fa-check-circle" />
                        </div>
                      </div>
                      <div style={{ fontSize: "24px", fontWeight: 700, lineHeight: 1.2 }}>
                        ₹{feeDashData.length===0?'0':Number(feeDashData[0].total_recieved || 0).toLocaleString('en-IN')}
                      </div>
                    </div>
                  </Link>

                  {/* Settled */}
                  <Link to={{pathname:'/AdminMain/TotalSettled'}} style={{textDecoration:'none'}}>
                    <div
                      style={{
                        background: "linear-gradient(135deg, #3b82f6, #2563eb)",
                        borderRadius: "12px",
                        padding: "16px 18px",
                        color: "#ffffff",
                        boxShadow: "0 4px 16px rgba(37, 99, 235, 0.25), 0 2px 4px rgba(37, 99, 235, 0.15)",
                        transition: "all 0.3s ease",
                        border: "1px solid rgba(255, 255, 255, 0.1)",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-2px)";
                        e.currentTarget.style.boxShadow = "0 6px 20px rgba(37, 99, 235, 0.35), 0 4px 8px rgba(37, 99, 235, 0.2)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 4px 16px rgba(37, 99, 235, 0.25), 0 2px 4px rgba(37, 99, 235, 0.15)";
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "8px" }}>
                        <div style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.08em", opacity: 0.9, fontWeight: 600 }}>
                          Settled
                        </div>
                        <div style={{
                          width: "32px",
                          height: "32px",
                          borderRadius: "8px",
                          backgroundColor: "rgba(255,255,255,0.2)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "14px",
                        }}>
                          <i className="fa fa-handshake" />
                        </div>
                      </div>
                      <div style={{ fontSize: "24px", fontWeight: 700, lineHeight: 1.2 }}>
                        ₹{feeDashData.length===0?'0':Number(feeDashData[0].due_settlement || 0).toLocaleString('en-IN')}
                      </div>
                        </div>
                     </Link> 
                  </div>  
                </div>

              {/* Actions Section */}
              <div
                style={{
                  background: "linear-gradient(135deg, #f8fafc 0%, #ffffff 100%)",
                  borderRadius: "12px",
                  border: "2px solid #e5e7eb",
                  padding: "12px 16px",
                  marginTop: "20px",
                  marginBottom: "20px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.03)",
                }}
              >
                <h5 style={{ margin: 0, marginBottom: "12px", fontSize: "16px", fontWeight: "700", color: "#111827", display: "flex", alignItems: "center", gap: "8px" }}>
                  <i className="fa fa-bolt" style={{ color: "#3b82f6", fontSize: "16px" }}></i>
                  Actions
                </h5>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", gap: "8px" }}>
                  {/* Collect Now */}
                  <Link to={{ pathname: "/AdminMain/FeeCollection" }} style={{ textDecoration: "none" }}>
                    <div style={{
                      background: "linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%)",
                      border: "1px solid #dcfce7",
                      borderRadius: "10px",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "6px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.borderColor = "#22c55e";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(34, 197, 94, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.borderColor = "#dcfce7";
                      e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                    }}
                    >
                      <div style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #22c55e, #16a34a)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 2px 6px rgba(34, 197, 94, 0.25)",
                      }}>
                        <i className="fa fa-rupee-sign" style={{ fontSize: "16px", color: "#ffffff" }}></i>
               </div>
                      <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>Collect Now</span>
                      </div>
                   </Link>   

                  {/* Fee Card */}
                  <Link to={{ pathname: "/AdminMain/FeeCard" }} style={{ textDecoration: "none" }}>
                    <div style={{
                      background: "linear-gradient(135deg, #eff6ff 0%, #ffffff 100%)",
                      border: "1px solid #dbeafe",
                      borderRadius: "10px",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "6px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.borderColor = "#3b82f6";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(59, 130, 246, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.borderColor = "#dbeafe";
                      e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                    }}
                    >
                      <div style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #3b82f6, #2563eb)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 2px 6px rgba(59, 130, 246, 0.25)",
                      }}>
                        <i className="fa fa-id-card" style={{ fontSize: "16px", color: "#ffffff" }}></i>
                </div>
                      <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>Fee Card</span>
                      </div>
                   </Link> 

                  {/* Payment History */}
                  <div style={{
                    background: "linear-gradient(135deg, #f5f3ff 0%, #ffffff 100%)",
                    border: "1px solid #e9d5ff",
                    borderRadius: "10px",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.borderColor = "#6366f1";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(99, 102, 241, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.borderColor = "#e9d5ff";
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                  }}
                  >
                    <div style={{
                      width: "36px",
                      height: "36px",
                      borderRadius: "50%",
                      background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 6px rgba(99, 102, 241, 0.25)",
                    }}>
                      <i className="fa fa-history" style={{ fontSize: "16px", color: "#ffffff" }}></i>
                </div>
                    <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>Payment History</span>
                  </div>

                  {/* Fee Receipt */}
                  <div style={{
                    background: "linear-gradient(135deg, #fff7ed 0%, #ffffff 100%)",
                    border: "1px solid #fed7aa",
                    borderRadius: "10px",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.borderColor = "#f97316";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(249, 115, 22, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.borderColor = "#fed7aa";
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                  }}
                  >
                    <div style={{
                      width: "36px",
                      height: "36px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #f97316, #ea580c)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 6px rgba(249, 115, 22, 0.25)",
                    }}>
                      <i className="fa fa-receipt" style={{ fontSize: "16px", color: "#ffffff" }}></i>
                    </div>
                    <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>Fee Receipt</span>
                  </div>

                  {/* Fee Structure */}
                  <Link to={{ pathname: "/AdminMain/FeeStructureManager" }} style={{ textDecoration: "none" }}>
                    <div style={{
                      background: "linear-gradient(135deg, #ecfeff 0%, #ffffff 100%)",
                      border: "1px solid #cffafe",
                      borderRadius: "10px",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "6px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.borderColor = "#0ea5e9";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(14, 165, 233, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.borderColor = "#cffafe";
                      e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                    }}
                    >
                      <div style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #0ea5e9, #0284c7)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 2px 6px rgba(14, 165, 233, 0.25)",
                      }}>
                        <i className="fa fa-layer-group" style={{ fontSize: "16px", color: "#ffffff" }}></i>
                      </div>
                      <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>Fee Structure</span>
                      </div>
                   </Link> 

                  {/* Special Case */}
                  <div style={{
                    background: "linear-gradient(135deg, #fdf2f8 0%, #ffffff 100%)",
                    border: "1px solid #fce7f3",
                    borderRadius: "10px",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.borderColor = "#ec4899";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(236, 72, 153, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.borderColor = "#fce7f3";
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                  }}
                  >
                    <div style={{
                      width: "36px",
                      height: "36px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #ec4899, #db2777)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 6px rgba(236, 72, 153, 0.25)",
                    }}>
                      <i className="fa fa-star" style={{ fontSize: "16px", color: "#ffffff" }}></i>
                    </div>
                    <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>Special Case</span>
                </div>  
               
                  {/* RTE */}
                  <div style={{
                    background: "linear-gradient(135deg, #f0fdf4 0%, #ffffff 100%)",
                    border: "1px solid #dcfce7",
                    borderRadius: "10px",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.borderColor = "#22c55e";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(34, 197, 94, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.borderColor = "#dcfce7";
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                  }}
                  >
                    <div style={{
                      width: "36px",
                      height: "36px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #22c55e, #16a34a)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 6px rgba(34, 197, 94, 0.25)",
                    }}>
                      <i className="fa fa-university" style={{ fontSize: "16px", color: "#ffffff" }}></i>
                    </div>
                    <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>RTE</span>
                  </div>

                  {/* Fee Wise */}
                  <div style={{
                    background: "linear-gradient(135deg, #faf5ff 0%, #ffffff 100%)",
                    border: "1px solid #e9d5ff",
                    borderRadius: "10px",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.borderColor = "#a855f7";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(168, 85, 247, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.borderColor = "#e9d5ff";
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                  }}
                  >
                    <div style={{
                      width: "36px",
                      height: "36px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #a855f7, #7c3aed)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 6px rgba(168, 85, 247, 0.25)",
                    }}>
                      <i className="fa fa-list" style={{ fontSize: "16px", color: "#ffffff" }}></i>
               </div>
                    <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>Fee Wise</span>
               </div>

                  {/* Class */}
                  <div style={{
                    background: "linear-gradient(135deg, #fefce8 0%, #ffffff 100%)",
                    border: "1px solid #fef08a",
                    borderRadius: "10px",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.borderColor = "#facc15";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(250, 204, 21, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.borderColor = "#fef08a";
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                  }}
                  >
                    <div style={{
                      width: "36px",
                      height: "36px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #facc15, #eab308)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 6px rgba(250, 204, 21, 0.25)",
                    }}>
                      <i className="fa fa-chalkboard-teacher" style={{ fontSize: "16px", color: "#111827" }}></i>
                </div>
                    <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>Class</span>
                </div>

                  {/* Class Wise */}
                  <div style={{
                    background: "linear-gradient(135deg, #ecfeff 0%, #ffffff 100%)",
                    border: "1px solid #cffafe",
                    borderRadius: "10px",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.borderColor = "#06b6d4";
                    e.currentTarget.style.boxShadow = "0 4px 12px rgba(6, 182, 212, 0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.borderColor = "#cffafe";
                    e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                  }}
                  >
                    <div style={{
                      width: "36px",
                      height: "36px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #06b6d4, #0ea5e9)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0 2px 6px rgba(6, 182, 212, 0.25)",
                    }}>
                      <i className="fa fa-layer-group" style={{ fontSize: "16px", color: "#ffffff" }}></i>
               </div>
                    <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>Class Wise</span>
                  </div>

                  {/* Old Due */}
                  <Link to={{pathname:'/AdminMain/OldDueList/'+1}} style={{textDecoration:'none'}}>
                    <div style={{
                      background: "linear-gradient(135deg, #f5f3ff 0%, #ffffff 100%)",
                      border: "1px solid #e9d5ff",
                      borderRadius: "10px",
                      padding: "10px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "6px",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                      boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateY(-2px)";
                      e.currentTarget.style.borderColor = "#6366f1";
                      e.currentTarget.style.boxShadow = "0 4px 12px rgba(99, 102, 241, 0.15)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.borderColor = "#e9d5ff";
                      e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.05)";
                    }}
                    >
                      <div style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "50%",
                        background: "linear-gradient(135deg, #6366f1, #4f46e5)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "0 2px 6px rgba(99, 102, 241, 0.25)",
                      }}>
                        <i className="fa fa-history" style={{ fontSize: "16px", color: "#ffffff" }}></i>
                      </div>
                      <span style={{ fontSize: "12px", fontWeight: 600, color: "#111827" }}>Old Due</span>
                    </div>
                  </Link>
                </div>
              </div>

              <div style={{margin:'5px 0px'}}>
                 <h3>
                   <Link
                     to={{ pathname: '/AdminMain/FeeCollection' }}
                     className="btn bg-primary btn-block text-white"
                     style={{ fontSize: '18px', textDecoration: 'none', padding: '10px' }}
                   >
                     Collect Fee
                   </Link>
                 </h3>
               </div>
               <div style={{margin:'5px 0px'}}>
                 <h3>
                   <Link
                     to={{ pathname: '/AdminMain/FeeStructureManager' }}
                     className="btn bg-success btn-block text-white"
                     style={{ fontSize: '18px', textDecoration: 'none', padding: '10px' }}
                   >
                     Manage Fee Structure
                   </Link>
                 </h3>
               </div>
                </div>
                {isOpenSessionDialog === true ? (
                  <MdlSelectSession
                    action={handleCloseSessionDialog}
                    action2={handleSelectedSession}
                  ></MdlSelectSession>
                ) : (
                  ''
                )}
              </div>
            </div>
  );
};

export default RevenueManagement;


